export default {"src":"/planos/_next/static/media/logo.d35f4885.svg","height":67,"width":446,"blurWidth":0,"blurHeight":0};